import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import style from './H1.scss'

function H1({ children, className }) {
  const componentClass = cx(style.h1, { [className]: className })
  return <h1 className={componentClass}>{children}</h1>
}

H1.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
}

export default H1



// WEBPACK FOOTER //
// ./src/components/Common/H1.js